/**
 * Whether a package should render its list price struck through.
 *
 * A promo price of `0` is a real discount — partner funnels (e.g. Toll
 * Brothers) run 100%-off promo codes — so this must not be a truthiness check.
 * Only an absent value, or one equal to the list price, means "no promo".
 */
export const hasPromoPrice = (
  price: number | undefined,
  promoPrice: number | undefined,
): promoPrice is number => promoPrice != null && promoPrice !== price;

/**
 * Whether the promo figure is worth showing next to the struck list price.
 *
 * When the promo total lands on zero the package is free, and "$0" adds
 * nothing the struck price and the card's own copy don't already say — so the
 * strikethrough stands alone. Takes the *total* (promo price plus any add-ons)
 * because a free package with paid add-ons still has a price to show.
 */
export const showsPromoTotal = (promoTotal: number) => promoTotal > 0;
